import { forwardRef } from 'react';

export interface InputContentProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const InputContent = forwardRef<HTMLDivElement, InputContentProps>(({
  children,
  className = '',
  ...props
}, ref) => {
  const contentClasses = [
    'flex-1',
    'max-h-[300px]',
    'py-2.5',
    'pl-4',
    'pr-2.5',
    'flex',
    'justify-start',
    'items-center',
    className
  ].filter(Boolean).join(' ');

  return (
    <div ref={ref} className={contentClasses} {...props}>
      <div className="flex-1 flex flex-col justify-center">
        {children}
      </div>
    </div>
  );
});

InputContent.displayName = 'InputContent';

export default InputContent;